import { useLocation } from 'react-router-dom'
import { SITE_PAGES } from '../lib/constants'

/**
 * Hook pour détecter la page actuelle de l'utilisateur
 * Utilisé pour pré-remplir le champ "page" dans le formulaire de ticket
 */
export function useCurrentPage() {
  const location = useLocation()

  // Cherche la page qui correspond au pathname actuel
  const currentPage = SITE_PAGES.find((page) => {
    if (!page.path) return false

    // Correspondance exacte ou correspondance de préfixe pour les sous-pages
    return location.pathname === page.path || location.pathname.startsWith(page.path + '/')
  })

  // Si aucune page trouvée, retourne "Autre / Général"
  return currentPage || SITE_PAGES[SITE_PAGES.length - 1]
}
